module.exports = __webpack_public_path__ + "static/media/light-padlock-icon.ea28a858.svg";